import {
  AHIcon,
  AHIconType,
  AHText,
  AHTodoCategoryIcon,
  Box,
  Circle,
  TodoCategoryIconType,
  TouchableBox,
  useSpaceSize,
} from "arkh";

export function EntityHeader(props: { children: React.ReactNode }) {
  const padding = useSpaceSize("medium") + useSpaceSize("small");
  return (
    <Box
      color="surface"
      borderColor="border-primary"
      style={{
        borderBottomWidth: 1,
        alignItems: "center",
        paddingTop: padding,
        paddingBottom: padding,
      }}
      gap="small"
    >
      {props.children}
    </Box>
  );
}
function EntityHeaderIcon(props: { icon: AHIconType }) {
  return (
    <Circle size="xlarge" borderColor="border-primary" borderWidth={1}>
      <AHIcon type={props.icon} size="large" color="text-secondary" />
    </Circle>
  );
}
function EntityHeaderTodoIcon(props: { icon: TodoCategoryIconType }) {
  return (
    <Circle size="xlarge" borderColor="border-primary" borderWidth={1}>
      <AHTodoCategoryIcon
        icon={props.icon}
        size="large"
        color="text-secondary"
      />
    </Circle>
  );
}

function EntityHeaderTitle(props: { children: React.ReactNode }) {
  return (
    <AHText
      spaceHorizontal="large"
      textAlign="center"
      type="title-big"
      color="text-primary"
    >
      {props.children}
    </AHText>
  );
}

function EntityHeaderButton(props: {
  children: React.ReactNode;
  onPress: () => void;
}) {
  return (
    <TouchableBox
      color="surface-backgroundControl"
      onPress={props.onPress}
      spaceHorizontal="medium"
      spaceVertical="small"
      cornerRadius="medium"
    >
      <AHText color="text-secondary" type="subtitle">
        {props.children}
      </AHText>
    </TouchableBox>
  );
}

EntityHeader.Title = EntityHeaderTitle;
EntityHeader.Button = EntityHeaderButton;
EntityHeader.Icon = EntityHeaderIcon;
EntityHeader.TodoCategoryIcon = EntityHeaderTodoIcon;
